import { createRouter, createWebHistory } from 'vue-router'
import Layout from '@/layout/index.vue'
import { getCurrentEnvConfig } from '@/config/env'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/index.vue'),
    hidden: true
  },
  {
    path: '/',
    component: Layout,
    redirect: '/home',
    children: [
      {
        path: 'home',
        name: 'Home',
        component: () => import('@/views/home/index.vue'),
        meta: { title: '首页' }
      }
    ]
  },

  {
    path: '/board',
    component: Layout,
    children: [
      {
        path: '',
        name: 'Board',
        component: () => import('@/views/board/index.vue'),
        meta: { title: '数据看板' }
      }
    ]
  },
  {
    path: '/banner',
    component: Layout,
    children: [
      {
        path: '',
        name: 'Banner',
        component: () => import('@/views/banner/index.vue'),
        meta: { title: 'Banner管理' }
      }
    ]
  },
  {
    path: '/user',
    component: Layout,
    children: [
      {
        path: '',
        name: 'User',
        component: () => import('@/views/user/index.vue'),
        meta: { title: '用户管理' }
      }
    ]
  },
  {
    path: '/device',
    component: Layout,
    children: [
      {
        path: '',
        name: 'Device',
        component: () => import('@/views/device/index.vue'),
        meta: { title: '设备管理' }
      }
    ]
  },
  {
    path: '/product',
    component: Layout,
    children: [
      {
        path: '',
        name: 'Product',
        component: () => import('@/views/product/index.vue'),
        meta: { title: '产品管理' }
      }
    ]
  },
  {
    path: '/settings',
    component: Layout,
    children: [
      {
        path: '',
        name: 'Settings',
        component: () => import('@/views/settings/index.vue'),
        meta: { title: '系统配置' }
      }
    ]
  },
  {
    path: '/translation',
    component: Layout,
    children: [
      {
        path: '',
        name: 'Translation',
        component: () => import('@/views/translation/index.vue'),
        meta: { title: '翻译管理' }
      }
    ]
  },
  {
    path: '/pet-breed',
    component: Layout,
    children: [
      {
        path: '',
        name: 'PetBreed',
        component: () => import('@/views/pet-breed/index.vue'),
        meta: { title: '宠物品种管理' }
      }
    ]
  },
  {
    path: '/pet',
    component: Layout,
    children: [
      {
        path: '',
        name: 'Pet',
        component: () => import('@/views/pet/index.vue'),
        meta: { title: '宠物管理' }
      }
    ]
  },
  {
    path: '/admin',
    component: Layout,
    children: [
      {
        path: '',
        name: 'Admin',
        component: () => import('@/views/admin/index.vue'),
        meta: { title: '系统管理员' }
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  // 获取当前环境的token
  const token = localStorage.getItem(
    getCurrentEnvConfig().tokenKey
  )

  if (to.path === '/login') {
    if (token) {
      next('/')
    } else {
      next()
    }
  } else {
    if (token) {
      next()
    } else {
      next('/login')
    }
  }
})

export default router 